import gql from 'graphql-tag';

export const usersQuery = gql`
  query Users {
    users {
      id
      firstName
      lastName
      fullName
      thumbUrl
      team {
        id
        name
      }
    }
  }
`;

export const tagsQuery = gql`
  query tags {
    tags {
      title
      status
      id
    }
  }
`;

export const entityQuery = gql`
  query entity {
    entity {
      id
      name
      registeredNumber
      logoUrl
      securityPassword
      isSmsSending
      countryCode
      currency
      timezone
      theme {
        name
        backgroundColor
        backgroundImage
        accentColor
        signButtonText
      }
    }
  }
`;
